var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators/custom-element.js";
export let NotFoundPage = class NotFoundPage extends LitElement {
    render() {
        return html ` <section className="pf-c-page__main-section pf-m-light">
      <Panel>
        <h3 slot="header">404! This view hasn't been created yet.</h3>
        <p>Go to page <a href="/products">home</a> page</p>
      </Panel>
    </section>`;
    }
};
NotFoundPage.styles = css `
    /* Your component's styles here */
    :host {
      display: block;
    }
  `;
NotFoundPage = __decorate([
    customElement("not-found")
], NotFoundPage);
